// Simple two-level category tree used by the shop and admin product modal
export type CategoryNode = {
  label: string;
  value: string;
  children?: CategoryNode[];
};

// This list is a curated two-level representation of the parts taxonomy provided.
// Top-level categories have a `children` array when appropriate.
export const CATEGORY_TREE: CategoryNode[] = [
  { label: 'All', value: 'all' },
  { label: 'Accessories', value: 'accessories', children: [
    { label: 'Books', value: 'books' },
    { label: 'Car Cleaning', value: 'car-cleaning' },
    { label: 'Car Cover', value: 'car-cover' },
    { label: 'Clothing', value: 'clothing' },
    { label: 'Jewelry', value: 'jewelry' },
    { label: 'Key Rings', value: 'key-rings' },
    { label: 'Paint', value: 'paint' },
    { label: 'Stickers', value: 'stickers' },
    { label: 'Tools', value: 'tools' },
    { label: 'Toys', value: 'toys' },
  ]},
  { label: 'Badges & Decals', value: 'badges-decals', children: [
    { label: 'Badges & Stickers', value: 'badges-stickers' },
    { label: 'Decals Stickers', value: 'decals-stickers' },
  ]},
  { label: 'Body', value: 'body', children: [
    { label: 'Bonnet', value: 'bonnet' },
    { label: 'Boot', value: 'boot' },
    { label: 'Doors', value: 'doors' },
    { label: 'Mirrors', value: 'mirrors' },
    { label: 'Windows', value: 'windows' },
    { label: 'Exterior Trim', value: 'exterior-trim' },
    { label: 'Panel', value: 'panel' },
    { label: 'Wings', value: 'wings' },
    { label: 'Subframes', value: 'subframes' },
  ]},
  { label: 'Brakes', value: 'brakes', children: [
    { label: 'Brake Kits', value: 'brake-kits' },
    { label: 'Discs', value: 'discs' },
    { label: 'Pads & Shoes', value: 'pads-shoes' },
    { label: 'Hydraulics', value: 'hydraulics' },
    { label: 'Master Cylinders', value: 'master-cylinders' },
  ]},
  { label: 'Electrical', value: 'electrical', children: [
    { label: 'Alternators', value: 'alternators' },
    { label: 'Ignition', value: 'ignition' },
    { label: 'Lights & Lamps', value: 'lights-lamps' },
    { label: 'Starters', value: 'starters' },
    { label: 'Relays & Switches', value: 'relays-switches' },
  ]},
  { label: 'Engine', value: 'engine', children: [
    { label: 'Gaskets', value: 'gaskets' },
    { label: 'Pistons & Rings', value: 'pistons-rings' },
    { label: 'Valves', value: 'valves' },
    { label: 'Camshafts', value: 'camshafts' },
    { label: 'Oil Pumps', value: 'oil-pumps' },
  ]},
  { label: 'Exhaust', value: 'exhaust', children: [
    { label: 'Manifolds', value: 'manifolds' },
    { label: 'Exhaust Systems', value: 'exhaust-systems' },
  ]},
  { label: 'Filters & Fluids', value: 'filters-fluids', children: [
    { label: 'Air Filters', value: 'air-filters' },
    { label: 'Fuel Filters', value: 'fuel-filters' },
    { label: 'Oil Filters', value: 'oil-filters' },
    { label: 'Oils', value: 'oils' },
  ]},
  { label: 'Fuel & Carburettors', value: 'fuel-carb', children: [
    { label: 'Carburettors', value: 'carburettors' },
    { label: 'Fuel Pumps', value: 'fuel-pumps' },
    { label: 'Tanks', value: 'tanks' },
  ]},
  { label: 'Gearbox & Drivetrain', value: 'gearbox-drivetrain', children: [
    { label: 'Gearbox', value: 'gearbox' },
    { label: 'Diffs', value: 'diffs' },
    { label: 'Driveshaft', value: 'driveshaft' },
    { label: 'CV Joints', value: 'cv-joints' },
  ]},
  { label: 'Interior', value: 'interior', children: [
    { label: 'Seats & Belts', value: 'seats-belts' },
    { label: 'Carpet & Mats', value: 'carpet-mats' },
    { label: 'Dash', value: 'dash' },
    { label: 'Trim', value: 'trim' },
  ]},
  { label: 'Steering & Suspension', value: 'steering-suspension', children: [
    { label: 'Shock Absorbers', value: 'shock-absorbers' },
    { label: 'Arms & Bushes', value: 'arms-bushes' },
    { label: 'Top Arms', value: 'top-arms' },
    { label: 'Subframes', value: 'subframes-sus' },
  ]},
  { label: 'Wheels & Tyres', value: 'wheels-tyres', children: [
    { label: 'Wheels', value: 'wheels' },
    { label: 'Nuts & Caps', value: 'nuts-caps' },
    { label: 'Tyres 10"', value: 'tyres-10' },
    { label: 'Tyres 12"', value: 'tyres-12' },
    { label: 'Tyres 13"', value: 'tyres-13' },
  ]},
  { label: 'Performance & Tuning', value: 'performance', children: [
    { label: 'Performance Parts', value: 'performance-parts' },
    { label: 'Quickshifts', value: 'quickshifts' },
  ]},
  { label: 'Misc', value: 'misc' }
];

export default CATEGORY_TREE;
